export enum FavoriteErrorCode {
  PATH_REQUIRED = 'PATH_REQUIRED',
  PATH_NOT_INTERNAL_RELATIVE = 'PATH_NOT_INTERNAL_RELATIVE',
  PATH_OR_FAVORITE_ID_REQUIRED = 'PATH_OR_FAVORITE_ID_REQUIRED',
  PATH_NOT_ALLOWED = 'PATH_NOT_ALLOWED',
  REORDER_PAYLOAD_INVALID = 'REORDER_PAYLOAD_INVALID',
}

export class FavoriteError extends Error {
  readonly code: FavoriteErrorCode;

  constructor(message: string, code: FavoriteErrorCode) {
    super(message);
    this.name = 'FavoriteError';
    this.code = code;
  }
}
